

<template>
    <BaseSection
        v-if="artists?.length || productionHouse || venue"
        width="content-sm"
        color-theme="light"
        class="event-relation-list"
    >
        <template #title>Meer details</template>

        <template #default>
            <ul class="artist-list__content list--clean">
                <template
                    v-for="item in onlyArtistsWithPage"
                    :key="item.id"
                >
                    <ArtistCard
                        :artist="item"
                        appearance="list"
                    />
                </template>

                <VenueCard
                    v-if="venue"
                    :venue="venue"
                    appearance="list"
                />

                <ProductionHouseCard
                    v-if="productionHouse"
                    :production-house="productionHouse"
                    appearance="list"
                />
            </ul>
        </template>
    </BaseSection>
</template>

<script setup lang="ts">
const props = defineProps<{
    artists?: ArtistRelation[];
    venue?: VenueRelation | null;
    productionHouse?: ProductionHouseRelation | null;
}>();

const onlyArtistsWithPage = computed(() =>
    props?.artists?.filter((artist) => artist.hasPage));
</script>

<style scoped lang="less">
.event-relation-list {
    ol, ul > li {
        padding-left: .25rem;
    }

    @media @q-sm-min {
        ol, ul > li {
            padding-left: .75rem;
        }
    }
}

.event-relation-list ul {
    li + li {
        margin-top: 1rem;
    }
}
</style>
